import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { StyledButton } from "../../../components/ListShowButton";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
});

const ConfirmButton = ({ id }: any) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleDelete, { loading }] = useMutation(
    {
      type: "delete",
      resource: "excludeBusAssistants",
      payload: { id },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully delete exclude bus assistant.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed delete exclude bus assistant, error: ${error.message}`,
          "warning",
        ),
    },
  );

  return (
    <Button
      onClick={handleDelete}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      disabled={loading}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const DeleteButton = (props: IExcludeBusAssistant) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Check if the existing excludeBusAssistant month/year
  // is in the past compared to current month/year.
  // This prevents to delete exclude bus assistant for past months
  const today = new Date();
  const isInvalidMonthToDelete =
    props.year < today.getFullYear() ||
    (props.year === today.getFullYear() && props.month < today.getMonth() + 1);

  const tooltipLabel = isInvalidMonthToDelete
    ? "Deletion allowed only for current or future months"
    : "Delete Exclude Bus Assistant";

  return (
    <Fragment>
      <Tooltip title={tooltipLabel}>
        {/*Wrap button in <span> to allows the tooltip to show even when the button is disabled*/}
        <span>
          <StyledButton
            variant="outlined"
            onClick={handleOpenDialog}
            disabled={isInvalidMonthToDelete}
          >
            Delete
          </StyledButton>
        </span>
      </Tooltip>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Delete The Exclude Bus Assistant
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            <Typography variant="body1" gutterBottom>
              Are you sure you want to delete the exclude bus assistant?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            label="Back"
            color="secondary"
            onClick={handleClose}
            className={classes.cancelButton}
          />
          <ConfirmButton id={props.id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DeleteButton;
